import { IInputWidget } from '../../../widgets/repository/inputs/IInputWidget';
import { Datatype } from '../../datatype/Datatype';
import { IReference, ReferenceType } from '../IReference';
import { IReferencePath } from '../IReferencePath';

export function getSimpleWidgetReference(
  type:
    | Datatype.Boolean
    | Datatype.Number
    | Datatype.Date
    | Datatype.String
    | Datatype.File
    | Datatype.Empty
    | Datatype.Hidden,
) {
  return (path: IReferencePath, widget: IInputWidget): IReference => {
    return {
      type: ReferenceType.Widget,
      widgetType: widget.type,
      path,
      id: widget.id,
      code: widget.code,
      label: widget.code,
      field: {
        type,
      },
    };
  };
}
